import {ControlledDatePicker} from 'components/hookForms';
import React from 'react';
import {Control} from 'react-hook-form';
import {useEditMatkonParagraphsFormTranslations} from '../../EditParagraphsForm/editParagraphsFormTranslationHooks';
import {
	MatkonSetLimitsType,
	MatkonFormLimitType,
	MatkonFormType,
	MatkonFormSetError,
	MatkonFormClearErrors,
} from '../MatkonTypes';

interface MatkonLegalEntryDatePickerProps {
	control: Control<MatkonFormType>;
	index: number;
	limit: MatkonFormLimitType;
	setLimits: MatkonSetLimitsType;
	setError: MatkonFormSetError;
	clearErrors: MatkonFormClearErrors;
}
export const MatkonLegalEntryDatePicker: React.FC<
	MatkonLegalEntryDatePickerProps
> = ({control, index, limit, setLimits, setError: setErrors, clearErrors}) => {
	const {t} = useEditMatkonParagraphsFormTranslations();
	const validate = (date: any) => {
		if (limit.deadlineInternal && date < new Date(limit.deadlineInternal)) {
			setErrors(`limits.${index}.deadlineInternal`, {
				message: t('InternalAfterDeadlineLaw'),
			});
			return t('InternalAfterDeadlineLaw');
		}
		clearErrors(`limits.${index}.deadlineInternal`);
		return true;
	};

	const onChange = (date: any) => {
		setLimits(prevLimits => {
			const newLimits = [...prevLimits];
			newLimits[index].deadlineLaw =
				date instanceof Date ? date.toISOString() : '';
			return newLimits;
		});
	};

	return (
		<ControlledDatePicker
			control={control}
			name={`limits.${index}.deadlineLaw`}
			label={t('LegalEntryDate')}
			defaultValue={new Date(limit.deadlineLaw)}
			onChange={onChange}
			rules={{
				required: t('DeadlineLawDateRequired'),
				validate,
			}}
		/>
	);
};
